import { libs, application } from '../../../../../core/backbone'

function fromLibsBag({ key }) {
  const libsContext = libs()
  delete libsContext[key]
}

function fromAppInstance({ name, version }) {
  const instance = application()

  for (const key in instance) {
    if (key.indexOf(`${name}-${version}`) !== -1) {
      delete instance[key]
    }
  }
}

function fromDocument({ name, version }) {
  document
    .querySelectorAll(
      `script[src*="${name}/${version}/"],
    link[href*="${name}/${version}/"]`,
    )
    .forEach(item => {
      /**
       * CSS design tokens assets are shared between MFEs (that use the same version) to avoid load the same file many times.
       *
       * Example: `mfe-a` use design tokens v1.0.0. `mfe-b` use design tokens v1.0.0 as well.
       * When the `mfe-a` is loaded first, the `mfe-b` not will load the same CSS asset.
       *
       * So, we prevent remove this assets here.
       */
      if (item.type === 'text/css') return

      item.remove()
    })
}

export default function removeMfeStuffs(mfe) {
  const { name, key, version } = mfe

  if (!name || !key || !version) return null

  const removers = [fromLibsBag, fromAppInstance, fromDocument]

  removers.forEach(fn => fn(mfe))
}
